import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import Navbar from "@/components/Navbar";
import Landing from "@/pages/Landing";
import DailyTheme from "@/pages/DailyTheme";
import DailyPromo from "@/pages/DailyPromo";
import Leaderboard from "@/pages/Leaderboard";
import Stats from "@/pages/Stats";
import HowToPlay from "@/pages/HowToPlay";
import About from "@/pages/About";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Admin from "@/pages/Admin";
import AdminPuzzle from "@/pages/AdminPuzzle";
import AdminWrestlers from "@/pages/AdminWrestlers";
import AdminWrestlerEdit from "@/pages/AdminWrestlerEdit";
import AdminBulkImport from "@/pages/AdminBulkImport";

function ProtectedAdmin({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="p-10 text-slate-400">Loading…</div>;
  if (!user || user.role !== "admin") return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <div className="min-h-screen arena-bg arena-grain">
      <Navbar />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/daily/theme" element={<DailyTheme />} />
        <Route path="/daily/promo" element={<DailyPromo />} />
        <Route path="/leaderboard" element={<Leaderboard />} />
        <Route path="/stats" element={<Stats />} />
        <Route path="/how-to-play" element={<HowToPlay />} />
        <Route path="/about" element={<About />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/admin" element={<ProtectedAdmin><Admin /></ProtectedAdmin>} />
        <Route path="/admin/puzzle/:id" element={<ProtectedAdmin><AdminPuzzle /></ProtectedAdmin>} />
        <Route path="/admin/new/:mode" element={<ProtectedAdmin><AdminPuzzle /></ProtectedAdmin>} />
        <Route path="/admin/wrestlers" element={<ProtectedAdmin><AdminWrestlers /></ProtectedAdmin>} />
        <Route path="/admin/wrestlers/import" element={<ProtectedAdmin><AdminBulkImport /></ProtectedAdmin>} />
        <Route path="/admin/wrestlers/new" element={<ProtectedAdmin><AdminWrestlerEdit /></ProtectedAdmin>} />
        <Route path="/admin/wrestlers/:id" element={<ProtectedAdmin><AdminWrestlerEdit /></ProtectedAdmin>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <footer className="mt-16 border-t border-slate-800 py-8 text-center text-xs text-slate-500 px-4">
        Popless is an unofficial fan trivia game and is not affiliated with, endorsed, or sponsored by WWE, AEW,
        or any professional wrestling organization. Gameplay audio is uploaded by the site operator from
        authorized sources; SoundCloud attribution (when shown after a puzzle ends) is hosted by SoundCloud.
      </footer>
    </div>
  );
}
